import { useBuilding } from "@/api";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useBuildingAdminOrReceptionistAccess } from "@/hooks/useReceptionistAccess";
import BookingOnBehalfOf from "@/components/bookings/BookingOnBehalfOf";
import { useWelcomeBookingAccess } from "@/hooks/useWelcomeBookingAccess";

export const Route = createFileRoute("/_portal/building/bookings/new")({
  component: NewBuildingBooking,
});

function NewBuildingBooking() {
  const { t } = useTranslation();
  const { allowWelcomeBookingAccess } = useWelcomeBookingAccess();
  const { allowBuildingAdminOrReceptionistAccess } =
    useBuildingAdminOrReceptionistAccess();
  const { data: building } = useBuilding();

  const breadcrumbs = [
    {
      label: t("SIDEBAR.BUILDING_BOOKINGS"),
      path: "/building/bookings",
    },
    {
      label: t("PAGES.BUILDING_BOOKING.NEW.HEADER"),
      path: "/building/bookings/new",
    },
  ];

  if (!allowBuildingAdminOrReceptionistAccess || !allowWelcomeBookingAccess)
    return null;
  return (
    <BookingOnBehalfOf
      breadcrumbs={breadcrumbs}
      headerContent={
        <>
          <h1>{t("PAGES.BUILDING_BOOKING.NEW.HEADER")}</h1>
          <p>
            {t("PAGES.BUILDING_BOOKING.NEW.SUBHEADER", {
              buildingName: building.displayName,
            })}
          </p>
        </>
      }
      onSuccessNavigateTo="/building/bookings"
    />
  );
}
